var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{attrs:{"for":"file"}},[_c('default-button',{attrs:{"icon":"mdi-camera","label":"Importar da Câmera do Celular"},on:{"click":_vm.open}}),_c('input',{ref:"file",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*","capture":_vm.isMobile?'camera':null},on:{"change":_vm.handleFileSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }